import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';
import './styles.css';
import FooterPage from './FooterPage'; 

const VerificationCode = ({ onSuccess, passcode }) => {
  const [verificationCode, setVerificationCode] = useState('');

  // const handleVerificationSubmit = () => {
  //   if (verificationCode === passcode) {
  //     onSuccess();
  //   }
  // };
// console.log(passcode)
  return (
    <Box className="verification-box">
    <div className= "container">
      <p className="verification-description" id="popup-description">
        Verification Code
      </p>
      {/* pull verification code */}
      <div className="verification-text">Copy the below code and paste it into the commissioning app.</div>
      <div className="verification-code">{passcode}</div>
      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleVerificationSubmit}
        className="regenerate-button"
      >
        Regenerate
      </Button> */}
    </div>
    <FooterPage />
    </Box>
  );
};

VerificationCode.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default VerificationCode;

